<template>
  <div class="customer">
    <van-sticky>
      <div class="header">
        <div class="headerIcon">
          <van-icon name="arrow-left" color="#fff" @click="returnIndex" />
          <van-search v-model="value" placeholder="查找" @input="searchInput" />
        </div>
      </div>
      <van-tabs v-model="active" class="tabAll" @click="activeChange">
        <van-tab title="全部" name="0"></van-tab>
        <van-tab title="待接待" name="3"></van-tab>
        <van-tab title="接待中" name="2"></van-tab>
        <van-tab title="接待完成" name="1"></van-tab>
      </van-tabs>
    </van-sticky>
    <div v-if="tableData">
      <div class="allProject" v-for="(item,index) in tableData" :key="index">
        <div @click="enterDetail(item)">
          <div class="facialName">
            <div class="facialNext">
              <div class="facialList">
                <img class="facialImg" src="../../assets/icon/me.png" alt="" style="">
                <span>{{item.projectName}}</span>
                <span>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</span>
                <img class="myself" src="../../assets/icon/myself.png" alt="">
                <img class="myself" src="../../assets/icon/vip.png" alt="">
              </div>
              <div class="nurseName">客服</div>
            </div>
          </div>
          <div class="outpatient">
            <img class="facialImg" src="../../assets/icon/me.png" alt="">
            <span>客服:</span>
            <span class="outName">{{item.doctorName}}</span>
          </div>
          <div class="outpatient">
            <img class="facialImg" src="../../assets/icon/me.png" alt="">
            <span>现场:</span>
            <span class="outName">{{item.doctorName}}</span>
          </div>
          <div class="outpatient">
            <img class="facialImg" src="../../assets/icon/me.png" alt="">
            <span>助理:</span>
            <span class="outName">{{item.doctorName}}</span>
          </div>
        </div>
        <div class="split_line"></div>
        <div class="concat">
          <div class="contactSer">更换客服</div>
          <div class="contactWait">确认接待</div>
          <div class="contactFinish">结束流程</div>
          <div class="contactChange">移交科室</div>
          <div class="contactLine">变更患者</div>
        </div>
      </div>
    </div>
    <div v-if="tableData.length==0">
      <div class="indexWhite">
        <img src="../../assets/img/my-white.png" alt="">
      </div>
      <div class="whitePart">暂无相关预约</div>
    </div>
  </div>
</template>
<script>
import {
  findAppointmentList,
  updateAppointmentStatusById
} from "@/axios/api";
import {
  Toast
} from 'vant';
export default {
  data() {
    return {
      active: '0',
      value: '',
      tableData: [],
      flag: true,
      status: '',
      doctorNo: '',
      scrollTop: ''
    }
  },
  created() {
    this.empId = JSON.parse(localStorage.getItem('userInfo')).empId,
      this.status = JSON.parse(localStorage.getItem('userInfo')).status
    this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
    // console.log(this.empId)
    console.log(this.$route.params.val)
    if (this.$route.params.val) {
      if (this.$route.params.val == 3) {
        this.active = "3"
        this.appointmentList(this.active, '');
      } else if (this.$route.params.val == 2) {
        this.active = "2"
        this.appointmentList(this.active, '');
      } else if (this.$route.params.val == 1) {
        this.active = "1"
        this.appointmentList(this.active, '');
      } else if (this.$route.params.val == 4) {
        this.appointmentList();
      }
    } else if (this.$route.params.val == undefined) {
      this.appointmentList()
    }
    console.log('this.status')
    console.log(this.status)
    if (this.status == 1) {
      this.flag = false
    } else if (this.status == 0) {
      this.flag = true
    }

  },
  methods: {
    returnIndex() {
      this.$router.push("/aboutUs")
    },
    // 编辑当条信息
    handEdit(row) {
      console.log(row)
      this.$router.replace({
        name: "editAppointment",
        query: row,
      });
    },
    // 查询预约列表
    appointmentList(
      operationStatus,
      name
    ) {
      findAppointmentList({
        operationStatus: operationStatus,
        userId: this.empId,
        name: name,
        userStatus: this.status,
        doctorNo: this.doctorNo,
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType'),
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            this.tableData = res.data;
          } else {
            Toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    activeChange(val, title) {
      this.appointmentList(val, this.value);
    },
    // 点击进入详情页
    enterDetail(item) {
      console.log(item);
      this.$router.push({
        name: "receptionDetails",
        query: item,
      });
    },
    // 取消预约
    sureFinish(row, val) {
      // 2-确认完成,1-取消
      console.log(row)
      console.log(val)
      let data = {
        appointmentId: row.appointmentId,
        operationStatus: val,
        projectType: row.projectType
      }
      updateAppointmentStatusById(data)
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            this.appointmentList(this.active, '');
            Toast.success('状态修改成功');
          } else {
            Toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 联系客户
    callPhone(phoneNumber) {
      console.log(phoneNumber)
      window.location.href = 'tel://' + phoneNumber
    },
    // 关键字查询
    searchInput(val) {
      this.appointmentList(this.active, this.value)
    }
  },
  //A>B>C  A>B刷新 C>B不刷新
  beforeRouteLeave(to, from, next) {
    // console.log(to.name)
    if (to.name === 'receptionDetails' || to.name === 'editAppointment') {
      from.meta.keepAlive = true;
      // console.log(from.meta.keepAlive)
    } else {
      from.meta.keepAlive = false;
      from.meta.ifDoFresh = true;
    }
    this.scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    document.documentElement.scrollTop || document.body.scrollTop
    next(); //不可缺少
  },
  //进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // document.body.scrollTop = vm.scrollTop
      window.scrollTo(0, vm.scrollTop);
    })
    next()
  },
  activated() {
    //开启了keepAlive:true后再次进入,这样就能得到最新数据
    if (this.$route.meta.ifDoFresh) {
      //重置ifDoFresh
      this.$route.meta.ifDoFresh = false;
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      this.status = JSON.parse(localStorage.getItem('userInfo')).status
      this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
      //获取列表数据方法第一参数为是否重置搜索条件和页数
      this.appointmentList(this.active, "");
      console.log(this.active)
    }
  },
}

</script>
<style scoped>
@import "../../assets/css/customer.css";
</style>



// WEBPACK FOOTER //
// src/components/customerReception/allCustomer.vue